<template>
  <div>
    <v-autocomplete
      :value="bu"
      :items="filterBUs"
      :label="label != null ? label : $i18n.t('Work Shift')"
      @change="changedTo"
      @click:clear="clear"
      :loading="loading"
      :clearable="clearable"
      :rules="rules"
      :search-input.sync="filter"
      ref="select"
      autocomplete="nope"
      :no-filter="true"
      v-if="hide === false"
    >
      <template v-slot:selection="data">
        <div ripple dense class="height32">
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float:right">mdi-check</v-icon>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { doGet } from "@/store/common/module/apis";
import Themeable from "vuetify/lib/mixins/themeable";

import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "ShiftSelect",
  props: {
    value: {
      default: false
    },
    corp: {
      default: null
    },
    label: {
      default: null
    },
    clearable: {
      default: false
    },
    autoSelect: {
      default: false
    },
    hideLone: {
      default: false
    },
    rules: {
      default: () => []
    }
  }
})
export default class ShiftSelect extends (Vue, Themeable) {
  bu = null;
  bus = [];
  loading = true;
  filter = "";
  hide = false;

  clear() {
    this.filter = "";
    this.bu = null;
    this.$emit("input", null);
  }

  get filterBUs() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.bus;
    const fs = this.bus.filter(function(s) {
      return s.name && s.name.toLowerCase().indexOf(filterby) >= 0;
    });
    return fs;
  }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) {
      this.bu = newVal;
    }
    if (newVal && newVal.name) {
      this.$emit("input", newVal._id);
    }
    if (!newVal) {
      this.$emit("input", null);
    }
  }

  selectValue() {
    if (this.bus && this.bus.length == 1 && this.hideLone !== false) {
      this.hide = true;
    }
    if (this.value) {
      for (let i = 0; i < this.bus.length; i++) {
        if (this.bus[i]._id === this.value) {
          this.bu = this.bus[i];
          return;
        }
      }
    }
    if (this.autoSelect !== false) {
      if (this.bus.length == 1) {
        this.bu = this.bus[0];
        this.$emit("input", this.bu._id);
        return;
      }
      for (let i = 0; i < this.bus.length; i++) {
        if (this.bus[i].isDefault == true) {
          this.bu = this.bus[i];
          this.$emit("input", this.bu._id);
          return;
        }
      }
    }
  }

  async init(val) {
    if (val != null && val !== "" && val != false) {
      this.filter = "";
      this.loading = true;
      this.bus = await doGet("/api/corp/" + val + "/dutyHours");
      this.loading = false;
      this.selectValue();
    } else {
      this.bus = [];
      this.loading = false;
      this.selectValue();
    }
  }

  async mounted() {
    await this.init(this.corp);
    this.loading = false;
  }

  selected(val) {
    if (
      val != null &&
      val._id != null &&
      this.bu != null &&
      this.bu._id != undefined
    ) {
      if (val._id === this.bu._id) {
        return true;
      }
    }
    return false;
  }

  @Watch("corp", { immediate: true })
  async onCorpChange(val) {
    await this.init(val);
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
</style>
